<template>
    <div class="weekwrap">
        <div class="weekTitle">
            {{weekTitle}}
        </div>
        <div class="dayList">
            <div class="dayView dayTitle" v-for="dow in 7" :key="dow" :class="{today: isToday(dow)}">
                <span class="link" @click="selectDay(dow)">{{dayTitle(dow)}}</span>
            </div>
        </div>
        <div class="alldayEvents">
            <div class="alldayView" v-for="dow in 7" :key="`a-${dow}`">
                <calendar-all-day-view :events="events" :date="viewStart.plus({days: dow-1})"></calendar-all-day-view>
            </div>
        </div>
        <div class="calendarWeek dayList">
            <div class="dayView" v-for="dow in 7" :key="dow">
                <calendar-day-view :events="events" :date="viewStart.plus({days: dow-1})"
                        :showTimes="dow===1"></calendar-day-view>
            </div>
        </div>
    </div>
</template>

<script>
import CalendarDayView from '@/components/calendarDayView';
import CalendarAllDayView from '@/components/calendarAllDayView';
import { DateTime } from 'luxon';

export default {
  name: 'calendarWeek',
  components: { CalendarDayView, CalendarAllDayView },
  props: {
    events: Array,
    startDate: Object
  },
  methods: {
    dayTitle(dow) {
      return this.viewStart.plus({ days: dow - 1 }).toLocaleString({ weekday: 'short', day: 'numeric' });
    },
    isToday(dow) {
      return this.viewStart.plus({ days: dow - 1 }).equals(this.today);
    },
    selectDay(dow) {
      this.$router.push(`/calendar/day/${this.viewStart.plus({ days: dow - 1 }).toFormat('yyyyMMdd')}`);
    },
    allDayEvents(dow) {
      const dayStart = this.viewStart.plus({ days: dow - 1 });
      const dayEnd = dayStart.endOf('day');
      let events = this.events.filter(e => {
        return (e.startDateTime <= dayEnd) && (e.endDateTime >= dayStart) && (e.allday);
      });

      return events;
    },
    selectEvent(event) {
      console.log('cal event click', event);
      this.$router.push(
        { name: 'calendarEvent', params: Object.assign({}, this.$route.params, { eventId: event.id }) });
    }
  },
  computed: {
    today() {
      return DateTime.local().startOf('day');
    },
    viewStart() {
      return this.startDate;
    },
    weekTitle() {
      return this.$t('weekTitle', { from: this.viewStart, to: this.viewStart.endOf('week') });
    },
    style() {
      return this.$store.getters.calendarEventStyles;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .weekwrap {
        display: flex;
        flex-direction: column;
        height: 100%;
        .weekTitle {
            flex: 0 0 auto;
            text-align: center;
            font-weight: bold;
        }
        .dayList {
            flex: 0 0 auto;
            display: flex;
            width: 100%;
            .dayView {
                flex: 1;
            }
            .dayTitle {
                text-align: center;
                &.today {
                    font-weight: bold;
                }
                .link {
                    &:hover {
                        text-decoration: underline;
                        cursor: pointer;
                    }
                }
            }
        }

        .alldayEvents {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            overflow-y: scroll;
            overflow-x: hidden;
            max-height: 5em;
            .alldayView {
                overflow-x: hidden;
                border-left: 1px solid $calendar-week-border;
            }
            border-bottom: 2px solid $calendar-week-border;
        }
        .calendarWeek {
            flex: 1;
            overflow-x: hidden;
            overflow-y: scroll;

            .dayView {
//                width: calc(100% / 7);
                height: 48 * $calendar-day-row;
                border-left: 1px solid $calendar-week-border;
            }
        }
    }

</style>
